import { useState } from "react";
import Slider from "react-slick";
import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import VideoModal from "../VideoModal/VideoModal";

import styles from "./styles.module.scss";
import VideoPlayButtonIcon from "../SVGs/VideoPlayButtonIcon";

const VideoCarousel = () => {
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState("");

  const openModal = (videoSrc: any) => {
    setCurrentVideo(videoSrc);
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    appendDots: (dots: any) => <div>{""}</div>,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  function SampleNextArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        <FontAwesomeIcon
          icon={faChevronRight}
          style={{ color: "#006633", fontSize: "28px" }}
        />
      </div>
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{ ...style, display: "block" }}
        onClick={onClick}
      >
        <FontAwesomeIcon
          icon={faChevronLeft}
          style={{ color: "#006633", fontSize: "28px" }}
        />
      </div>
    );
  }

  return (
    <div className={styles.videoCarousel}>
      <h2>{t("trustedThousandsPets")}</h2>
      <div className="container">
        <Slider {...settings}>
          <div className={styles.sliderItem} onClick={() => openModal("assets/videos/v1.mp4")}>
            <div className={styles.backdrop}>
              <div className={styles.playBtnWrapper}><VideoPlayButtonIcon /></div>
            </div>
            <video src="assets/videos/v1.mp4" autoPlay muted loop />
          </div>
          <div className={styles.sliderItem} onClick={() => openModal("assets/videos/v2.mp4")}>
            <div className={styles.backdrop}>
              <div className={styles.playBtnWrapper}><VideoPlayButtonIcon /></div>
            </div>
            <video src="assets/videos/v2.mp4" autoPlay muted loop />
          </div>
          <div className={styles.sliderItem} onClick={() => openModal("assets/videos/v3.mp4")}>
            <div className={styles.backdrop}>
              <div className={styles.playBtnWrapper}><VideoPlayButtonIcon /></div>
            </div>
            <video src="assets/videos/v3.mp4" autoPlay muted loop />
          </div>
        </Slider>
      </div>
      <VideoModal
        isOpen={isModalOpen}
        onClose={closeModal}
        videoSrc={currentVideo}
      />
    </div>
  );
};

export default VideoCarousel;
